var map = {
	"./ar/canvas.json": "./src/locale/ar/canvas.json",
	"./cy/canvas.json": "./src/locale/cy/canvas.json",
	"./cz/canvas.json": "./src/locale/cz/canvas.json",
	"./da/canvas.json": "./src/locale/da/canvas.json",
	"./de/canvas.json": "./src/locale/de/canvas.json",
	"./en/canvas.json": "./src/locale/en/canvas.json",
	"./es/canvas.json": "./src/locale/es/canvas.json",
	"./fi/canvas.json": "./src/locale/fi/canvas.json",
	"./fr/canvas.json": "./src/locale/fr/canvas.json",
	"./hu/canvas.json": "./src/locale/hu/canvas.json",
	"./it/canvas.json": "./src/locale/it/canvas.json",
	"./ja/canvas.json": "./src/locale/ja/canvas.json",
	"./ko/canvas.json": "./src/locale/ko/canvas.json",
	"./kz/canvas.json": "./src/locale/kz/canvas.json",
	"./nl/canvas.json": "./src/locale/nl/canvas.json",
	"./pl/canvas.json": "./src/locale/pl/canvas.json",
	"./pt/canvas.json": "./src/locale/pt/canvas.json",
	"./ro/canvas.json": "./src/locale/ro/canvas.json",
	"./ru/canvas.json": "./src/locale/ru/canvas.json",
	"./sk/canvas.json": "./src/locale/sk/canvas.json",
	"./sv/canvas.json": "./src/locale/sv/canvas.json",
	"./vn/canvas.json": "./src/locale/vn/canvas.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locale sync recursive ^\\.\\/.*\\/canvas\\.json$";